import { render, staticRenderFns } from "./DataPagination.vue?vue&type=template&id=bfdd7358&scoped=true"
import script from "./DataPagination.vue?vue&type=script&lang=js"
export * from "./DataPagination.vue?vue&type=script&lang=js"
import style0 from "./DataPagination.vue?vue&type=style&index=0&id=bfdd7358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdd7358",
  null
  
)

export default component.exports